<template>
    <vehicle-catalog />
</template>

<script>
import VehicleCatalog from './components/VehicleCatalog.vue'

export default {
  name: 'App',
  components: {
    'vehicle-catalog': VehicleCatalog
  }
}
</script>

<style lang="scss">

* {
box-sizing: border-box;
}
#erc-vehicle-catalogue-app {
  margin: 0;
  padding: 0;
  font-family: 'Open Sans', sans-serif;
  font-weight: 300;
}
</style>
